import {
  KalturaBooleanValue,
  KalturaDoubleValue,
  KalturaLongValue,
  KalturaMultilingualStringValueArray,
  KalturaStringValue,
} from '@kaltura-ott/ott-client-types/api/types';
import { KalturaMultilingualStringValue } from '@kaltura-ott/ott-client-types/api/types/KalturaMultilingualStringValue';

import { toBoolean } from './common';
import { KalturaCategoryTags } from './tags';

export type KalturaCategoryMeta = KalturaBooleanValue | KalturaDoubleValue | KalturaLongValue | KalturaStringValue;

export interface KalturaCategoryMetas {
  [key: string]: KalturaCategoryMeta;
}

export interface KuxCategoryMetas {
  [key: string]: boolean | number | string;
}

export interface KuxMultiTags {
  [key: string]: string[];
}

export const normalizeCategoryMetas = (metas: KalturaCategoryMetas): KuxCategoryMetas => {
  const normalizedMeta: KuxCategoryMetas = {};

  if (metas) {
    Object.keys(metas).forEach((key) => (normalizedMeta[key] = metas[key].value));
  }

  return normalizedMeta;
};

const normalizeCategoryTagGroup = (tag: KalturaMultilingualStringValueArray): string[] => {
  return tag.objects.map((singleTag: KalturaMultilingualStringValue) =>
    singleTag.value ? singleTag.value : singleTag.multilingualValue[singleTag.multilingualValue.length - 1].value,
  );
};

export const normalizeCategoryTags = (tags: KalturaCategoryTags): KuxMultiTags => {
  const normalizedTags: KuxMultiTags = {};
  Object.keys(tags).forEach((key) => (normalizedTags[key] = normalizeCategoryTagGroup(tags[key])));

  return normalizedTags;
};

export const getParentalRating = (tags: KuxMultiTags): number => {
  const parseRating = tags['ParentalRating'] ? parseInt(tags['ParentalRating'][0], 10) : 0;
  return Number.isNaN(parseRating) ? 0 : parseRating;
};

export const getAdult = (metas: KuxCategoryMetas): boolean => {
  return toBoolean(metas['Adult']);
};

interface TagKeyValue {
  [key: string]: string;
}

export const parseTagKeyValue = (tagValue: string) => {
  return tagValue.split(',').reduce((acc: TagKeyValue, keyValue) => {
    const value = keyValue.split('=');
    acc[value[0]] = value[1];

    return acc;
  }, {});
};
